import TAGS from "../../../businessLayer/constants/Tags";
export function hasSGPBagde(tags) {
    return (tags.includes(TAGS.TAGS.SPORTCAST_BET_BUILDER))
        || (tags.includes(TAGS.TAGS.SGP));
}
//# sourceMappingURL=hasSGPBagde.js.map